import { MouseEventHandler } from 'react';

import { LinkProps } from '@core/type';
import { PagedEntity } from '@core/type/api';

export enum EPaginationStep {
  FIRST = 'first-page-btn',
  PREV = 'prev-page-btn',
  NEXT = 'next-page-btn',
  LAST = 'last-page-btn',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PaginationProps = Omit<Omit<PagedEntity<any>, 'page'>, 'items'> & {
  onPageChange: (page: number) => void;
  page: number;
};

export type PaginationLinkProps = LinkProps<{
  isActive: boolean;
  onClick?: () => void;
  page: number;
}>;

export type PaginationLinkArrowProps = Omit<
  LinkProps<{
    page?: number;
    isDouble?: boolean;
    isLeft?: boolean;
    label?: EPaginationStep;
    onClick?: MouseEventHandler<HTMLButtonElement>;
  }>,
  'children'
>;
